interface PaginationHelper {
  hasNPlusOne: boolean;
  currentListLength: number;
  pageSize: number;
  total: number;
  page?: number;
}

export const shouldDisableNextNavigation = ({
  hasNPlusOne,
  currentListLength,
  pageSize,
  total,
  page = 1,
}: PaginationHelper) => {
  if (total) {
    return pageSize * page >= total;
  }

  return hasNPlusOne ? currentListLength <= pageSize : currentListLength < pageSize;
};
